import { mapState, mapActions } from 'vuex';
import router from '@/services/router.js';

export default  {	
	data () {
		return { 
			users: { email: null, password: null},
		}
	},
	created()
	{		
		if(this.user!==null && this.logged)
		{
			router.push('/afiliado/ficha');
		}					
	},
	computed: { 
	  ...mapState({
		  logged                  : state => state.authStore.logged, 
		  errornotification       : state => state.authStore.errornotification, 
	  })   
	},
	methods: {
	  ...mapActions({    
		  login:     'authStore/login',  
		  errorNot:     'authStore/errorNot',  
	  })
	}
}
